import { render, staticRenderFns } from "./AKSnackbar.vue?vue&type=template&id=37951f28&scoped=true&"
import script from "./AKSnackbar.vue?vue&type=script&lang=js&"
export * from "./AKSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./AKSnackbar.vue?vue&type=style&index=0&id=37951f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37951f28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
